import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const product_epd = apiUrl + "/product_epd";
const routes = {
  label: "Product EPD",
  root: product_epd,
  get_by_category: product_epd + "/get_by_category",
  get_manufacturers: product_epd + "/get_manufacturers",
  get_by_manufacturer: product_epd + "/get_by_manufacturer",
};
export const Product_EPD = {
  label: routes.label,
  get_by_category: (category) => postWithToken(routes.get_by_category, { category }),
  get_manufacturers: () => postWithToken(routes.get_manufacturers),
  get_by_manufacturer: (manufacturer) => postWithToken(routes.get_by_manufacturer, { manufacturer }),
};

